const listItems = value => {
    value = value.replaceAll('<li><p>', '<li>')
    value = value.replaceAll('</p></li>', '</li>')

    return value
}

export default listItems
